import api from '../../plugins/api';

// POST /api/crm/vin-blacklist — добавить один VIN с причиной. Уже в списке — 409.
const addVinToBlacklist = ({ vin, reason }) => {
  return api.post('/api/crm/vin-blacklist', { vin, reason });
};

export default addVinToBlacklist;
